import {createStore} from 'vuex'
import mutations from './mutations'
import actions from './action'

const state = {
    username: '',//登录用0
    cartCount: 0,//购物车商品数量
    catId:'',
    catParentId:'',
    userInfo:'',
    setting:'',
    cat_list:'',
    home_info:''
}
export default createStore({
    state,
    mutations,
    actions
});
